package or.garden.manager.features.irrigation

import androidx.compose.runtime.Composable
import or.garden.manager.components.CardSkeleton
import or.garden.manager.domain.model.IrrigationResponse
import or.garden.manager.features.irrigation.components.WebIrrigationCard
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.Text

@Composable
fun IrrigationScreen(
    isLoading: Boolean,
    schedules: List<IrrigationResponse>,
    onWatered: (Int) -> Unit,
    onDelete: (Int) -> Unit
) {
    if (isLoading) {
        Div({
            classes("grid", "grid-cols-1", "md:grid-cols-2", "lg:grid-cols-3", "gap-4", "md:gap-8")
        }) {
            repeat(3) { CardSkeleton() }
        }
    } else if (schedules.isEmpty()) {
        Div({ classes("text-center", "py-20", "text-gray-400") }) {
            I({ classes("fas", "fa-tint-slash", "text-4xl", "mb-4") })
            H2 { Text("Nema postavljenih rasporeda navodnjavanja.") }
        }
    } else {
        Div({
            classes("grid", "grid-cols-1", "md:grid-cols-2", "lg:grid-cols-3", "gap-4", "md:gap-8")
        }) {
            schedules.forEach { item ->
                WebIrrigationCard(
                    item,
                    onWatered = { onWatered(item.id) },
                    onDelete = { onDelete(item.id) }
                )
            }
        }
    }
}
